import React from "react";
import { Navigate, useLocation } from "react-router";

import useDashboardLink from "src/hooks/useDashboardLink";

export default function InventoryMoveSearchRoute() {
  const dashboardLink = useDashboardLink();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  searchParams.set("moveModal", "true");
  searchParams.set("manualSearch", "true");

  return <Navigate to={`${dashboardLink}?${searchParams.toString()}`} replace />;
}
